<!-- https://www.primefaces.org/primeng/#/tooltip -->
<button
    #anchor
    [id]="buttonId"
    [ngClass]="_styleClass"
    [ngStyle]="style"
    (click)="handleClick($event)"
>
    <ng-template #labelTemplate>
        @if (!label) {
            <span class="sr-only">
                {{ text | translate }}
            </span>
        }

        @if (label) {
            <span style="overflow: hidden; white-space: nowrap; text-overflow: ellipsis">
                {{ label | translate }}
            </span>
        }
    </ng-template>

    @if (labelPosition === "left") {
        <ng-container *ngTemplateOutlet="labelTemplate"></ng-container>
    }

    @if (showSpinner) {
        <app-loading-spinner />
    }

    @if (icon) {
        <app-svg-icon
            [divClass]="_iconDivClass"
            [divStyle]="iconDivStyle"
            [fill]="fill"
            [icon]="icon"
            [ngClass]="iconClass"
            [ngStyle]="iconStyle"
            [tooltipDisabled]="disabled"
            [tooltipPosition]="tooltipPosition"
            tooltip="{{ text | translate }}"
        >
        </app-svg-icon>
    }

    @if (labelPosition === "right") {
        <ng-container *ngTemplateOutlet="labelTemplate"></ng-container>
    }
</button>
